export const isAdmin = (pathname: string) => {
  return pathname.includes('/admin')
}
